var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPrefixMoreBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "qh7ylo2b1a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.235294 0 0 0 0 0.364706 0 0 0 0 0.949020 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "gt6blcaqxb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15 -8)",
    filter: "url(#qh7ylo2b1a)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 8)",
    filter: "url(#gt6blcaqxb)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#B6BFCE"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M14 13v2H4V6h2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M6 4h10v9H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 6.5-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M10.5 6.5h3v3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrefixMoreBlue);
export default __webpack_public_path__ + "static/media/ico-prefix-more-blue.00144874197611325d4fd1d810108709.svg";
export { ForwardRef as ReactComponent };